import { Component, h, Prop, State, Element } from '@stencil/core';
import { _BREAKPOINTS_ } from 'utils';

@Component({
    tag: 'kdx-hero-slide-item',
    styleUrl: 'kdx-hero-slide-item.scss'
})
export class KdxHeroSlideItem {

    @Element() root: HTMLElement;

    @Prop() desktopImg: string;
    @Prop() mobileImg: string;
    @Prop() imageAlt: string;

    @State() bgImage: string;    

    componentWillLoad() {
        this.setImg();

        window.addEventListener('resize', () => {
            this.setImg();
        });
    }

    setImg() {
        if (!Boolean(this.mobileImg) || this.mobileImg == '') {
            this.bgImage = this.desktopImg;
        } else if (window.innerWidth >= _BREAKPOINTS_['md']) {
            this.bgImage = this.desktopImg;
        } else {
            this.bgImage = this.mobileImg;
        }
    }

    render() {
        return (
            <div class="kdx-hero-slide-item">
                <div class="hero-content">
                    <div class="container-fluid">
                        <div class="hero-content-block">
                            <slot/>                                
                        </div>
                    </div>
                </div>
                <kdx-lazy-img css-class="hero-img" img-src={this.bgImage} img-alt={this.imageAlt}></kdx-lazy-img>                
            </div>
        );
    }
}
